import { useQuery } from "@tanstack/react-query"
import { Guid } from "../app/models/CustomType"
import { FileVersionGet } from "../app/models/FileVersion"
import { digitalManagerApi } from "../services/api"

export function useFileVersions(fileId?: Guid) {
  const { data: fileVersions = [], isLoading: isLoadingFileVersions } = useQuery({
    queryKey: ["fileVersions", fileId],
    queryFn: () =>
      digitalManagerApi
        .get<FileVersionGet[]>(`/files/${fileId}/versions`)
        .then((r) => r.data),
    enabled: !!fileId,
  })

  return {
    fileVersions,
    isLoadingFileVersions,
  }
}
